import styled, { css } from "styled-components";
import SwipeableViews from "react-swipeable-views";
import buildColor from "@fdr/static-ui/ColorPalette";
import { fontBold } from "@fdr/static-ui/Typography";

import ButtonDefault from "../../_atoms/ButtonDefault";
import { buildText } from "../../_atoms/Text";

export const TutorialMainWrapper = styled.section`
  display: flex;
  flex-direction: column;
  ${(props) => css`
    ${props.isPrompt &&
    css`
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      top: 0;
      margin: auto;
      z-index: 999;
    `};
    ${props.device === "mobile"
      ? css`
          width: 100%;
          height: 100%;
        `
      : css`
          width: 414px;
          min-height: 520px;
        `};
    background-color: red;
    overflow: hidden;
  `};
`;

export const MainPanelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  position: relative;
  background-color: ${buildColor("white", "100")};
  padding: 16px 24px;
  overflow: hidden;

  .finalTutorialButton {
    width: 100%;
  }

  .mainTitle {
    margin-top: 6px;
    margin-bottom: 2px;
  }
`;

export const TutorialPaginationWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 32px;

  .navTutorialButton {
    width: 100%;
    margin-left: 16px;
  }

  & > nav {
    width: 100%;
    height: 32px;
    margin-top: 0;
  }

  & > button {
    background-color: ${buildColor("blue", "500")};
    min-width: 72px;

    &:hover {
      background-color: ${buildColor("grey", "100")};
    }
  }
`;

export const CloseButton = styled(ButtonDefault)`
  border: 0;
  border-radius: 0;
  background: none;
  position: absolute;
  top: 16px;
  right: 16px;
`;

export const TutorialSlidePanel = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  & > h1 {
    font-family: ${fontBold};
  }
`;

export const Description = styled(
  buildText({
    tag: "p",
    fontSize: 16,
    color: buildColor("grey", "900"),
    bold: false,
    qaLabel: "onboarding-slideDescription"
  })
)`
  margin-top: 8px;
  display: block;
  text-align: center;
`;

export const TutorialWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  position: relative;
`;

export const ImageWrapper = styled.div`
  height: 304px;
  overflow: hidden;
  position: relative;
  background-color: ${(props) =>
    props.isPrompt ? "transparent" : buildColor("blue", "100")};
  ${(props) =>
    props.isPrompt
      ? css`
          background-position: center center;
          background-size: contain;
          background-repeat: no-repeat;
        `
      : css`
          padding: 16px;

          > img {
            position: absolute;
            top: 0;
            left: 50%;
            transform: translate(-50%, 0);
            width: 100%;
            padding: 16px 16px 0;
          }
        `}
`;

export const TutorialSlidesContainer = styled(SwipeableViews)`
  display: flex;
  flex-grow: 1;
  position: relative;
  background-color: ${buildColor("white", "100")};

  > div {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
`;

export const TutorialSlideItem = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  width: 100%;
  height: 100%;
`;

export const TutorialBottomControls = styled.div`
  padding: 24px 12px;
  background-color: ${buildColor("white", "100")};
`;
